import React from "react";
import styles from "./AdventureInfo.module.css";
import { FaUsers, FaBookOpen, FaMountain } from "react-icons/fa";

const features = [
  {
    icon: <FaUsers />,
    title: "Collaboration",
    text: "Represents the organic collaboration growing members as we tackle adventures.",
  },
  {
    icon: <FaBookOpen />,
    title: "Club Represents",
    text: "A collection of emerging and consolidating lore that we discover and document together.",
  },
  {
    icon: <FaMountain />,
    title: "Adventure",
    text: "Represents an invitation into discovery, learning, and exploring a greater world.",
  },
];

const AdventureInfo = () => {
  return (
    <section className={styles.container}>
      <h2 className={styles.title}>Skydiving Festival 2025</h2>
      <p className={styles.description}>
        The "Skydiving Festival 2025" is taking place in Jamshedpur, Jharkhand,
        from February 16th to 23rd at Sonari Airport. This is Jharkhand's
        first-ever skydiving festival, organized by the Jharkhand Tourism
        Department and Sky High India. The festival will feature participants
        skydiving from 8,500 feet, with the inaugural jump by KK Pandey and
        Swati Chakravarty.
      </p>

      <img
        src="/images/sky-diving/sky-diving.JPG"
        alt="Paragliders in the sky"
        className={styles.mainImage}
      />

      <div className={styles.featuresGrid}>
        {features.map((feature, index) => (
          <div key={index} className={styles.featureItem}>
            <div className={styles.icon}>{feature.icon}</div>
            <h3 className={styles.featureTitle}>{feature.title}</h3>
            <p className={styles.featureText}>{feature.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AdventureInfo;
